export const sidebarConstant = {
    GET_EMPLOYEE_PERMISSION_SUCCESS: 'app/sidebar/GET_EMPLOYEE_PERMISSION_SUCCESS',
    GET_EMPLOYEE_PERMISSION_METADATA: 'app/sidebar/GET_EMPLOYEE_PERMISSION_METADATA'
}